<template>
  <div class="c-header-bar" :class="{ 'c-header-bar--scrolled': isDark }">
    <ul class="c-header-bar__inner">
      <!-- burger -->
      <li class="c-header-bar__inner__burger"><app-header-bar-burger /></li>
      <!-- logo -->
      <li class="c-header-bar__inner__logo">
        <app-header-bar-logo />
      </li>
      <!-- date -->
      <li class="c-header-bar__inner__time">
        <app-header-time />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

import AppHeaderBarBurger from "components/AppHeader/AppHeaderBar/AppHeaderBarBurger";
import AppHeaderBarLogo from "components/AppHeader/AppHeaderBar/AppHeaderBarLogo";
import AppHeaderTime from "components/AppHeader/AppHeaderTime";

export default {
  components: {
    AppHeaderBarBurger,
    AppHeaderBarLogo,
    AppHeaderTime
  },
  data() {
    return {
      navBarScrollTrigger: null,
      isUserScrolled: false
    };
  },
  computed: {
    ...mapState({
      isDark: state => state.navigation.isDark
    })
  },
  mounted() {
    this.killExistingScrollTrigger();
    this.$nextTick(() => {
      this.runScrollTrigger();
    });
  },
  beforeDestroy() {
    this.killExistingScrollTrigger();
  },
  methods: {
    killExistingScrollTrigger() {
      this.navBarScrollTrigger ? this.navBarScrollTrigger.kill() : null;
    },
    runScrollTrigger() {
      this.navBarScrollTrigger = ScrollTrigger.create({
        trigger: ".c-header-bar",
        horizontal: false,
        start: "+=100vh", // this is a placeholder
        onEnter: () => {
          this.toggleBackgroundClass(true);
        },
        onEnterBack: () => {
          this.toggleBackgroundClass(false);
        }
      });
    },
    toggleBackgroundClass(bool) {
      this.isUserScrolled = bool;
    }
  }
};
</script>

<style lang="scss">
.c-header-bar {
  @include transition(0.3s ease all);
  @include shadow($nav-line-mobile);
  position: relative;
  z-index: 100;
  padding: 1rem 1.5em;
  display: flex;
  width: 100%;
  height: 100%;

  &--scrolled {
    @include shadow($nav-line-mobile-transparent);
    background: $color-dark;
    @media #{$breakpoint-horizontal} {
      /* background: none; // maybe there will be something there */
    }
  }

  @media #{$breakpoint-horizontal} {
    @include shadow($nav-line-desktop);
    min-width: var(--header-size); // To udpate to only rem
  }

  &__inner {
    @include reset-list;
    position: relative;

    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media #{$breakpoint-horizontal} {
      flex-direction: column;
      justify-content: space-between;

      height: 100%;
    }

    &__burger {
      order: 2;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      @media #{$breakpoint-horizontal} {
        order: 1;
      }
    }

    &__logo {
      order: 1;
      display: flex;
      position: relative;
      @media #{$breakpoint-horizontal} {
        order: 2;
      }
    }

    &__time {
      order: 3;
      position: relative;
      display: none;
      @media #{$breakpoint-horizontal} {
        display: block;
      }
    }
  }
}
</style>
